import VerifyEmailForm from '@/components/auth/VerifyEmailForm'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

const VerifyEmail = () => {
  return (
    <Card className="w-full max-w-md">
      <CardHeader>
        <CardTitle className="text-2xl">Verify Email</CardTitle>
      </CardHeader>
      <CardContent>
        <VerifyEmailForm />
      </CardContent>
    </Card>
  )
}

export default VerifyEmail